import client from '../../../../services/client';

const createSocialPost = ({
  businessId,
  contentType,
  socialNetwork,
  scheduledDate,
  imageRefId,
  mediaId,
  message,
  flow,
}: {
  businessId: string,
  contentType: string,
  socialNetwork: string,
  scheduledDate: string,
  imageRefId?: string,
  mediaId?: string,
  message?: string,
  flow: string,
}) => {
  return client
    .businesses.for(businessId)
    .social.posts.create({
      socialNetwork,
      contentType,
      scheduledDate,
      imageRefId,
      mediaId,
      message,
      flow,
    })
    .catch((err: Error & { messageId: string, context: any }) => {
      // If the error is "this social post already exists", then we've won!
      if (err.messageId === '25-67-013') {
        return {
          id: err.context.context, // id of the existing social post
        };
      }
      throw err;
    });
};

export default createSocialPost;
